<template>
    <el-dialog
        title="地图选址"
        :visible.sync="visible"
        destroy-on-close
        top="5vh"
        custom-class="mapClass"
        :close-on-click-modal="false"
        :before-close="cancel"
        :append-to-body="true"
        width="70%"
    >
        <div :style="{ height: '100%' }">
            <div :id="mapId" :style="{ height: '100%' }"></div>
            <div class="location-map">
                <el-autocomplete
                    popper-class="map-input-popper"
                    v-model="address"
                    :fetch-suggestions="handleFetch"
                    placeholder="请输入地址搜索"
                    @select="handleSelect"
                >
                    <template #default="{ item }">
                        <div class="title">{{ item.title }}</div>
                        <div class="address">{{ item.address }}</div>
                    </template>
                </el-autocomplete>
            </div>
        </div>
        <template #footer>
            <el-button
                type="primary"
                class="btn"
                :loading="loading"
                @click="sure"
                >确定
            </el-button>
            <el-button class="btn" @click="cancel">取消</el-button>
        </template>
    </el-dialog>
</template>

<script>
import loadMap from './loadBMap.js';
import { addressGeocoding } from '@/modules/transport/otp/api/performanceDispatchMgmt.js';

export default {
    name: 'AddressMapModal',
    data () {
        return {
            mapId: 'BMap-' + parseInt(Date.now() + Math.random()),
            map: '',
            NewBMap: '',
            visible: false,
            loading: false,
            type: '',
            address: '',
            point: {},
            returnAddress: '',
            mapTitle: '',
            local: null,
            geocoder: null,
            queryCallback: null,
            firstTime: false
        };
    },
    methods: {
        mapInit (address) {
            loadMap().then(BMap => {
                this.NewBMap = BMap;
                this.map = new BMap.Map(this.mapId);
                this.local = this.initLocalSearch(this.map);
                if (address) {
                    this.firstTime = true;
                    this.handleLocation(address);
                } else {
                    // 设初始化地图位置
                    this.map.centerAndZoom(new BMap.Point('113.216596', '22.913121'), '15');
                    // 允许地图可被鼠标滚轮缩放
                    this.map.enableScrollWheelZoom(true);
                    // 地图控件
                    var navigationControl = new BMap.NavigationControl({
                        anchor: 'BMAP_ANCHOR_TOP_LEFT', // 控件将定位到地图的左上角
                        type: 'BMAP_NAVIGATION_CONTROL_LARGE' // 标准的平移缩放控件
                    });
                    // 将控件添加到地图
                    this.map.addControl(navigationControl);
                }
                const that = this;
                this.map.addEventListener('click', function (e) {
                    that.mapClick(e);
                });
            });
        },
        // 初始化地图搜索
        initLocalSearch (map) {
            const local = new this.NewBMap.LocalSearch(map, {
                // 智能搜索
                onSearchComplete: async results => {
                    const len = results.getNumPois();
                    if (len <= 0) {
                        this.queryCallback && this.queryCallback([]);
                        return this.$message.warning('没有搜索到相关地址');
                    }
                    map.enableScrollWheelZoom(true);
                    if (!this.geocoder) {
                        this.geocoder = new this.NewBMap.Geocoder();
                    }
                    const addressOptions = await this.getAddressOption(results, len);
                    this.$nextTick(() => {
                        this.queryCallback && this.queryCallback(addressOptions);
                        if (this.firstTime) {
                            this.setMarker(addressOptions[0]);
                            this.firstTime = false;
                        }
                    });
                }
            });
            return local;
        },
        async getAddressOption (results, len) {
            const result = [];
            for (let i = 0; i < len; i++) {
                if (i < 10) {
                    // 根据坐标进行反地址解析, 获取更详细的地址信息
                    const addressOption = await this.getLocationAsync(this.geocoder, results.getPoi(i).point);
                    result.push(addressOption);
                }
            }
            return result;
        },
        getLocationAsync (geocoder, point) {
            return new Promise((resolve, reject) => {
                geocoder.getLocation(point, function(result) {
                    if (result) {
                        const { address: fourAddress, addressComponents, surroundingPois, point } = result;
                        if (surroundingPois.length) {
                            const { province, city, district, street } = addressComponents;
                            const detailAddress = surroundingPois[0].address.replace(province, '').replace(city, '').replace(district, '').replace(street, '');
                            resolve({ title: surroundingPois[0].title, address: fourAddress + detailAddress, point });
                        }
                    }
                });
            });
        },
        mapClick (e) {
            if (!this.geocoder) {
                this.geocoder = new this.NewBMap.Geocoder();
            }
            const that = this;
            this.geocoder.getLocation(e.point, function (result) {
                const { address: fourAddress, addressComponents, surroundingPois, point } = result;
                if (surroundingPois.length) {
                    const { province, city, district, street } = addressComponents;
                    const detailAddress = surroundingPois[0].address.replace(province, '').replace(city, '').replace(district, '').replace(street, '');
                    that.address = fourAddress + detailAddress + surroundingPois[0].title;
                    that.setMarker({ title: surroundingPois[0].title, address: fourAddress + detailAddress, point });
                    that.addressOptions = [];
                    for (let i = 0; i < surroundingPois.length; i++) {
                        if (i < 10) {
                            that.addressOptions.push(surroundingPois[i]);
                        }
                    }
                }
            });
        },
        // 点击确认
        sure () {
            if (!this.returnAddress) return this.$message.warning('请选择地址');
            const address = this.returnAddress + this.mapTitle;
            this.loading = true;
            const { lng, lat } = this.point;
            addressGeocoding({ address: address })
                .then(res => {
                    if (res && +res.code === 0) {
                        const { code, province, city, county, name, address } = res.data;
                        const type = this.type;
                        this.visible = false;
                        this.$emit(
                            'setSelectedAddress',
                            {
                                [`${type}ProvinceCode`]: code && code.length > 2 ? code.slice(0, 3) : '',
                                [`${type}ProvinceName`]: province,
                                [`${type}CityCode`]: code && code.length > 4 ? code.slice(0, 5) : '',
                                [`${type}CityName`]: city,
                                [`${type}DistrictCode`]: code && code.length > 6 ? code.slice(0, 7) : '',
                                [`${type}DistrictName`]: county,
                                [`${type}TownCode`]: code,
                                [`${type}TownName`]: name,
                                [`${type}Lng`]: lng,
                                [`${type}Lat`]: lat,
                                address: address
                            },
                            type
                        );
                    }
                })
                .catch(() => {
                    this.$message.warning('未获取到当前所选地址的详细信息，请重新选择');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 添加地图打标
        setMarker (addressOption) {
            const { title, address, point } = addressOption;
            const marker = new this.NewBMap.Marker(point);
            // 创建信息窗口
            const opts = {
                width: 250,
                title
            };
            this.map.clearOverlays(); // 清除地图上所有覆盖物
            this.map.centerAndZoom(point, '18');
            this.map.addOverlay(marker); // 添加标注
            this.map.setViewport([point]); // 最佳视角

            this.mapTitle = title;
            this.returnAddress = address;
            this.point = point;
            const infoWindow = new this.NewBMap.InfoWindow('地址:' + address + title, opts); // 创建信息窗口对象
            this.map.openInfoWindow(infoWindow, point); // 开启信息窗口
        },
        // 远程搜索
        handleFetch (query, callback) {
            if (query) {
                this.handleLocation(query);
                this.queryCallback = callback;
            } else {
                // eslint-disable-next-line standard/no-callback-literal
                callback([]);
            }
        },
        // 定位
        handleLocation (query) {
            if (query) {
                this.local.search(query);
            }
        },
        // 打开地图
        open (address, type) {
            this.visible = true;
            this.address = address;
            this.type = type;
            this.mapInit(address);
        },
        // 关闭地图弹窗
        cancel () {
            this.visible = false;
        },
        // 远程搜索选中
        handleSelect (val) {
            this.address = val.address + val.title;
            this.setMarker(val);
        }
    }
};
</script>

<style lang="less">
.mapClass {
    .el-dialog__body {
        position: relative;
        height: 500px;
        .location-map {
            position: absolute;
            top: 2%;
            right: 1%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px 10px;
            border-radius: 4px;
            background-color: #fff;
            box-shadow: 0 0 5px #f2f2f2;
            .el-autocomplete .el-input__inner {
                width: 560px;
            }
        }
    }
}
</style>
